import { Pipe, PipeTransform } from '@angular/core';
import { SimpleNumberValueFormatter } from '../helpers/number-formatter.helper';

@Pipe({ name: 'numberValueFormater' })
export class NumberValueFormatterPipe implements PipeTransform {
  transform(value: any, decimal?: number): any {
    return SimpleNumberValueFormatter(value, decimal);
  }
}
